import { useMutation } from "@tanstack/react-query";
import api from "apis";

export const useSaveTempDocumentMutation = () => {
  return useMutation({ mutationFn: api.document.saveDocumentTemp });
};
